import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	wrapperMain: {
		height: "auto", backgroundColor: theme.palette.common.white, paddingRight: "20px", paddingLeft: "20px", fontSize: "18px"
	},
	borderDefault: {
		border: "1px solid #DDDDDD",
		borderRadius: "5px"
	},
	marginTop10: {
		marginTop: theme.spacing.unit
	},
	searchWrapper: {
		paddingTop: "15px",
		marginLeft: "12px",
		marginRight: "10px",
		position: "relative"
	},
	link: { fontSize: "12px", color: "#2196F3", marginBottom: "20px" },
	chipStyle:
		{ float: "left", padding: "10px", margin: "7px", borderRadius: "40px", border: "1px solid #DFDFDF", backgroundColor: "#DFDFDF", marginTop: "19px" },
	checkboxCSS: {
		color: "#4CAF50",
		'&$checked': {
			color: "#43A047",
		},
	},
	checked: {},
	height40: {
		height: "40px"
	},
	breadCrumbs: {
		float: "left",
		padding: "10px",
		margin: "7px",
		borderRadius: "40px",
		border: "1px solid #DFDFDF",
		backgroundColor: "#DFDFDF",
		marginTop: "19px"
	},
	// searchList: {
	// 	zIndex: 9999,
	// 	maxHeight: "250px",
	// 	overflowY: "scroll",
	// 	position: "absolute",
	// 	width: "100%",
	// 	marginTop: "-5px",
	// 	paddingBottom: "20px"
	// },
	paper: {
		zIndex: 1,
		width: "100%",
		maxHeight: "170px"
	},
	margin: {
		margin: theme.spacing.unit
	},
	marginSyllabus: {
		marginTop: theme.spacing.unit,
		marginBottom: theme.spacing.unit
	},
	breadSyllabus: {
		padding: "5px 10px 5px 10px", 
		borderRadius: "40px", 
		border: "1px solid #DFDFDF", 
		backgroundColor: "#DFDFDF", 
		marginLeft: "5px",
		color: "rgba(0, 0, 0, 0.543846)"
	},
	borderBox: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		width:"100%"
	},

	avatarBig: {
		height: 100,
		width: 100,
		margin: '0 auto',
		backgroundColor: '#F7FAFB',
		border: '2px solid #D2E1E5',
	},
	searchConceptRoot: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		padding: `0 ${theme.spacing.unit}px`,
		height:"45px",
		marginBottom:"10px"
	},
	searchConceptBox: {
		borderBottom: `1px solid ${theme.palette.grey[300]}`,
		padding: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 3,
		position: 'relative',
		'&:after': {
			content: '"OR"',
			position: 'absolute',
			bottom: 0,
			left: '50%',
			transform: 'translate(-50%, 50%)',
			backgroundColor: theme.palette.grey[300],
			borderRadius: '50%',
			height: theme.spacing.unit * 3,
			width: theme.spacing.unit * 3,
			padding: theme.spacing.unit / 2,
			boxSizing: 'content-box',
			fontStyle: 'italic',
			fontFamily: theme.typography.fontFamily,
			fontSize: theme.typography.fontSize,
			lineHeight: 1.65,
			color: theme.palette.text.secondary,
		},
	},
	exploreConceptBox: {
		padding: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 3,
		'& button': {
			backgroundColor: theme.palette.common.white,
		}
	},

	breadcrumb: {
		listStyle: 'none',
		display: 'inline-flex',
		paddingLeft: 0,
		margin: 0,
		'& li': {
			...theme.typography.caption,
			display: 'inline-block',
			marginRight: theme.spacing.unit / 2,
			'&:after': {
				content: '">"',
				marginLeft: theme.spacing.unit / 2,
			},
			'&:only-child': {
				'&:after': {
					display: 'none',
				}
			},
			'&:last-child': {
				'&:after': {
					display: 'none',
				}
			},
		},
	},
	selectedBreadCrumb: {
		listStyle: 'none',
		display: 'flex',
		alignItems: 'center',
		paddingLeft: 0,
		margin: 0,
		marginBottom: theme.spacing.unit,
		'& li': {
			...theme.typography.body2,
			display: 'inline-block',
			marginRight: theme.spacing.unit / 2,
			'&:after': {
				content: '">"',
				marginLeft: theme.spacing.unit / 2,
			},
			'&:only-child': {
				'&:after': {
					display: 'none',
				}
			},
			'&:last-child': {
				'&:after': {
					display: 'none',
				}
			},
		},
	},
	chipItem: {
		'& > div': {
			margin: theme.spacing.unit / 2,
			marginTop: 0,
		},
		'&:after': {
			display: 'none',
		},
	},
	suggestContainer: {
		position: 'relative',
	},
	suggestList: {
		position: 'absolute',
		top: '34px',
		left: '0',
		background: '#fff',
		boxShadow: '0px 0px 2px #ccc',
		padding: 0,
		zIndex: 10,
		listStyleType: 'none',
		marginTop: 0,
		width: '100%',
	},
	suggestItem: {
		padding: theme.spacing.unit,
		paddingBottom: theme.spacing.unit + 4,
		cursor: 'pointer',
		zIndex: 11,
		'&::after': {
			content: '',
			display: 'table',
			clear: 'both',
		}
	},
	suggestBtn: {
		float: 'right',
		marginRight: '10px',
		height: '30px',
	},
	selectedConcept: {
		background: `${theme.palette.primary.main} !important`,
	},
	mb2x: {
		marginBottom: theme.spacing.unit * 2,
	},
});